import moment from 'moment'

export const dischargePort = {
  id: '',
  name: '',
  countryId: '',
  countryName: '',
  createdBy: '',
  updatedBy: '',
  createdAt: moment().format('YYYY-MM-DD'),
  updatedAt: moment().format('YYYY-MM-DD'),
}